export const gridSchemaEnhancer = ({ formData, schema, intl }) => {
  schema.properties = {
    ...schema.properties,
    portrait_images: {
      title: 'Portrait Images',
      type: 'boolean',
    },
  };
  schema.fieldsets[0].fields.push('portrait_images');
  return schema;
};
